export const supplier_scorecards = {
   id: "supplier_scorecards",
   title: "Supplier Scorecards",
   family: "supplier_scorecards",
   endpoint: "/runscorecards.sz",
   defaultSort: { key: "match_pct", dir: "asc" },
   groupBy: ["tier"],
   groupOptions: [
      { value: "tier",     label: "Tier" },
      { value: "supplier", label: "Supplier" },
   ],
   categoryField: "tier",
   categoryLabel: "Tier",
   minField: "variance_total",
   minLabel: "Min variance $",
   params: [
      { key: "period", type: "month", label: "Period" },
      { key: "locations", type: "multiselect", label: "Locations" },
      { key: "suppliers", type: "multiselect", label: "Suppliers" },
      { key: "minVariance", type: "number", label: "Min $" },
   ],
   summary: [
      { key: "suppliers",   label: "Suppliers",      type: "int",   agg: "count" },
      { key: "variance",    label: "Total variance", type: "money", agg: "sum", column: "variance_total" },
      { key: "outstanding", label: "$ Outstanding",  type: "money", agg: "sum", column: "outstanding" },
   ],
   columns: [
      { key: "supplier",       label: "Supplier",  type: "text",  align: "left" },
      { key: "statements",     label: "Statements", type: "int",   align: "right" },
      { key: "lines",          label: "Lines",     type: "int",   align: "right" },
      { key: "full_matched",   label: "Fully matched", type: "int",   align: "right" },
      { key: "partial",        label: "Partial",   type: "int",   align: "right" },
      { key: "unmatched",      label: "Unmatched", type: "int",   align: "right" },
      { key: "match_pct",      label: "Match rate", type: "percent", align: "right" },
      { key: "variance_total", label: "Variance $", type: "money", align: "right", total: "sum", accent: true },
      { key: "outstanding",    label: "Outstanding $", type: "money", align: "right", total: "sum" },
      { key: "tier",           label: "Tier",      type: "label", align: "left" },
   ],
};
